module.exports = __webpack_public_path__ + "static/media/admin3y4juntos.abcef62.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audios/admin3y4juntos.mp3
// module id = 715
// module chunks = 1